import Choices from "choices.js";

// 生成した Choices インスタンスを要素ごとに保持する。
// - turbo:load / turbo:render の二重発火による多重初期化を防ぐ
// - turbo:before-cache でまとめて destroy し、素の <select> に戻すために使う
const instances = new Map<HTMLSelectElement, Choices>();

const apply = () => {
  // .selectbox は <select> に付与される想定のため select 要素に限定し、
  // 意図しない要素へクラスが付いた場合の実行時エラーを防ぐ。
  const elements = document.querySelectorAll<HTMLSelectElement>("select.selectbox");
  elements.forEach((element) => {
    // 既に初期化済みの要素はスキップする。
    // element.dataset.choice === "active" は、キャッシュ復元などで
    // 変換済みDOMが残っているケースへのフォールバック。
    if (instances.has(element) || element.dataset.choice === "active") return;

    // 除去ボタンを無効化したい要素には data-disable-remove-item="true" を付与する。
    const disableRemoveItem = element.dataset.disableRemoveItem === "true";

    const choices = new Choices(element, {
      allowHTML: false,
      editItems: true,
      removeItemButton: !disableRemoveItem,
      shouldSort: false,
      // Choices.jsのデフォルトは検索結果が4件に制限されるため、無制限にする（-1）
      searchResultLimit: -1,
      noResultsText: "選択肢がありません", // 検索結果がないときに表示するメッセージ
      noChoicesText: "該当する結果がありません", // 選択可能なオプションがないときに表示するメッセージ
      itemSelectText: "クリックして選択してください",
      classNames: {
        containerOuter: "choices",
        containerInner: "choices__inner",
        input: "choices__input",
        inputCloned: "choices__input--cloned",
        list: "choices__list",
        listItems: "choices__list--multiple",
        listSingle: "choices__list--single",
        listDropdown: "choices__list--dropdown",
        item: "choices__item",
        itemSelectable: "choices__item--selectable",
        itemDisabled: "choices__item--disabled",
        itemChoice: "choices__item--choice",
        placeholder: "choices__placeholder",
        group: "choices__group",
        groupHeading: "choices__heading",
        button: "choices__button",
        activeState: "is-active",
        focusState: "is-focused",
        openState: "is-open",
        disabledState: "is-disabled",
        highlightedState: "is-highlighted",
        selectedState: "is-selected",
        flippedState: "is-flipped",
        loadingState: "is-loading",
        noResults: "has-no-results",
        noChoices: "has-no-choices",
      },
    });
    instances.set(element, choices);
  });
};

// Turbo がページをキャッシュする前に Choices を破棄し、素の <select> へ戻す。
// これをしないと data-choice="active" が付いた変換済みDOMがそのままキャッシュされ、
// 戻る操作での復元時に Choices が「初期化済み」とみなして再初期化を握り潰すため、
// イベントリスナが復活せずクリックしても無反応になる。
const teardown = () => {
  instances.forEach((choices) => choices.destroy());
  instances.clear();
};

const initialSelectbox = () => {
  ["turbo:load", "turbo:render"].forEach((event) => document.addEventListener(event, apply));
  document.addEventListener("turbo:before-cache", teardown);
};

export default initialSelectbox;
